<template lang="pug">
span
  v-menu(
    v-model="menuOpen"
    rounded="lg"
    allow-overflow
    attach
    :close-on-content-click="false"
    offset-y
    :max-height="maxHeight"
    :min-width="minWidth"
    :max-width="maxWidth"
    nudge-bottom="8"
    :content-class="contentClass"
  )
    template(v-slot:activator="{ on, attrs }")
      slot(name="activator" :on="on" :attrs="attrs" :isActive="isActive" :clear="handleClear")
        v-btn.px-2.button-text-normal.button-filter.text-none(
          v-if="isActive"
          outlined
          rounded
          height="28"
          v-bind="attrs"
          v-on="on"
        )
          v-icon.mr-1(@click.stop="handleClear" size="13") $yzi-x-circle
          .text-xs.font-semibold {{ label }}
          .px-1.neutral400--text |
          .text-xs.primary--text.font-medium {{ displayValue }}
          v-icon.ml-1(size="16") $yzi-chevron-down
        v-btn.px-2.button-text-normal.border-dashed.button-filter(
          v-else
          outlined
          rounded
          height="28"
          v-bind="attrs"
          v-on="on"
        )
          v-progress-circular.mr-1(v-if="loading" :width="2" :size="11" indeterminate)
          v-icon.mr-1(v-else size="13") $yzi-plus-circle
          .text-xs.text-none.font-semibold {{ label }}

    .white(style="border-radius: inherit;")
      div(v-if="showHeader")
        slot(name="header")
          .font-semibold.px-4.pt-4.text-sm {{ headerText || `${$t('filter_by')} ${label.toLowerCase()}` }}

      slot

    .bottom-0.sticky.z-1.white(v-if="showFooter" style="border-radius: inherit;")
      .d-flex.align-center.px-4.py-3.border-t
        slot(name="footer-left")
          .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(
            v-if="isActive && !disableClear"
            @click="handleClear"
          ) {{ clearText || $t('clear') }}
        v-spacer
        slot(name="footer-right")
          v-btn.button-sm(
            @click="handleApply"
            color="primary"
            depressed
            :disabled="disableApply"
          ) {{ applyText || $t('apply') }}
</template>

<script>
export default {
  name: 'YzFilterMenu',
  props: {
    // Display props
    label: {
      type: String,
      required: true
    },
    displayValue: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },

    // Menu configuration
    maxHeight: {
      type: [Number, String],
      default: 360
    },
    minWidth: {
      type: [Number, String],
      default: 320
    },
    maxWidth: {
      type: [Number, String],
      default: 320
    },
    contentClass: {
      type: String,
      default: 'custom-menu'
    },

    // Header props
    headerText: {
      type: String,
      default: ''
    },
    showHeader: {
      type: Boolean,
      default: true
    },

    // Footer props
    showFooter: {
      type: Boolean,
      default: true
    },
    clearText: {
      type: String,
      default: ''
    },
    applyText: {
      type: String,
      default: ''
    },
    disableClear: {
      type: Boolean,
      default: false
    },
    disableApply: {
      type: Boolean,
      default: false
    },

    // Control menu state externally
    value: {
      type: Boolean,
      default: undefined
    }
  },
  data() {
    return {
      internalMenuOpen: false
    }
  },
  computed: {
    menuOpen: {
      get() {
        return this.value !== undefined ? this.value : this.internalMenuOpen
      },
      set(val) {
        this.internalMenuOpen = val
        this.$emit('input', val)
        this.$emit('update:menu', val)
      }
    }
  },
  methods: {
    handleClear() {
      this.$emit('clear')
    },
    handleApply() {
      this.menuOpen = false
      this.$emit('apply')
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}

::v-deep {
  .custom-menu {
    overflow: unset;
    contain: unset;
  }
}
</style>
